export const AI_UNAVAILABLE_MESSAGE = 'Low credits, AI Chat unavailable - Contact the Admin';
export const AI_KEY_REFUSED_MESSAGE = 'AI is unavailable: the provider key was refused. Contact the Admin.';
const listeners = new Set();
export const aiFailureCode = error => (typeof error === 'string' ? error : null) || error?.response?.data?.code || error?.response?.data?.error?.code || error?.code || error?.error?.code || error?.error_code;
export const subscribeAiCreditFailure = listener => { listeners.add(listener); return () => listeners.delete(listener); };
export function observeAiCreditFailure(error) {
  if (aiFailureCode(error) !== 'AI_CREDITS_EXHAUSTED') return false;
  listeners.forEach(listener => listener({ available: false, reason: 'credits', message: AI_UNAVAILABLE_MESSAGE })); return true;
}
export function aiCreditErrorMessage(error) {
  if (aiFailureCode(error) === 'AI_CREDITS_EXHAUSTED') { observeAiCreditFailure(error); return AI_UNAVAILABLE_MESSAGE; }
  return aiFailureCode(error) === 'AI_PROVIDER_KEY_INVALID' ? AI_KEY_REFUSED_MESSAGE : null;
}
